// extracted by mini-css-extract-plugin
export default {"nav":"ProductsPagination_nav__lghk0","pagNumber":"ProductsPagination_pagNumber__Q9F3b","currPage":"ProductsPagination_currPage__4d9Z1"};